import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import {PaqueteSeguros} from '../_models/paquete-seguros';
import {MatrizIdentidad} from '../_models/matriz-identidad';
import {ProductosRespaldos} from '../_models/productos-respaldos';
import {ProductoGarantia} from '../_models/producto-garantia';
@Injectable({
  providedIn: 'root'
})
export class ProductosRespaldosService{
  private rutServicio = AppSettings.rutServiciosAPL + '/api/productosRespaldos';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as ProductosRespaldos[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as ProductosRespaldos[] ) );
  }

  listadoPorProducto( idProducto: string ) {
    return this.httClient.get( this.rutServicio + '/producto/' + idProducto ).pipe( map( res => res as ProductosRespaldos[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as ProductosRespaldos ) );
  }

  crear( regCrear: ProductosRespaldos ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ProductosRespaldos ) );
  }

  actualizar( regActualizar: ProductosRespaldos ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }
}
